export type BooleanType = 'true' | 'false';

export interface AdriverCustom {
  1: 'Kiraye' | 'Alis';
  5: 1 | 2 | 3 | 4 | 5 | number;
  6: string;
  7: BooleanType;
  8: string;
  9: number;
  10: BooleanType;
  11: BooleanType;
}

export enum TargetedBannerIds {
  bg = 'js-lotriver-bg-banner',
  catfish = 'catfish',
  gallery = 'banner-gallery',
  fullscreenGallery = 'fullscreen-banner-gallery'
}

export enum TargetedBannerKeys {
  'js-lotriver-bg-banner' = 'bgBanner',
  'catfish' = 'catfishBanner',
  'banner-gallery' = 'galleryBanner',
  'fullscreen-banner-gallery' = 'fullscreenGalleryBanner'
}

export interface Adriver {
  loadCompleteQueue: { flag: boolean };
  prm: { custom: AdriverCustom };
  reqPrm: { custom: string };
  custom: AdriverCustom;
  reload: () => unknown;
  p?: HTMLElement;
}

export interface GoogletagSlot {
  addService: (service: unknown) => unknown;
}

declare global {
  interface Window {
    adriver: {
      (id: string | TargetedBannerIds, options: object): Adriver;
      new (id: string | TargetedBannerIds, options: object): Adriver;
    };
    isPopState: boolean;
    dataLayer?: Record<string, unknown>[];
    google: unknown;
    googletag?: {
      cmd: Array<() => void>;
      defineSlot: (
        id: string,
        sizes: number | number[],
        blockId: string
      ) => GoogletagSlot | null;
      enableServices: () => void;
      pubads: () => unknown;
      display: (blockId: string) => void;
      destroySlots: (slots?: GoogletagSlot[]) => boolean;
    };
    MSStream: unknown;
    bgBanner?: Adriver;
    catfishBanner?: Adriver;
    galleryBanner?: Adriver;
    fullscreenGalleryBanner?: Adriver;
    adriverExtentionLoad: (
      a: number,
      b: number | null,
      containerId: string
    ) => boolean | void;
  }
}

export enum ButtonLocation {
  MobileHeader = 'Mobile header',
  DeskHeader = 'Desk header',
  MobileMenu = 'Mobile menu',
  DeskCabinet = 'Desk cabinet'
}
